import { useMemo } from 'react';
import { useDynamicCreatorForm } from '../../forms/dynamic-form/dynamic-creator-form.hook';
import { useDynamicEditorForm } from '../../forms/dynamic-form/dynamic-editor-form.hook';
import { useSettingsTreeReducerContext } from '../../reducer/settings-tree-reducer.context';
import { SettingsEditorPanel } from './settings-editor-panel.component';

export interface SettingsEditorPanelProps {
  nodeId: string | null;
}

export function SettingsEditorPanelContainer() {
  const { currentFormState } = useSettingsTreeReducerContext();

  if (!currentFormState) {
    return null;
  }

  if (currentFormState.formType === 'create') {
    return <CreatorPanelContainer />;
  } else {
    return <EditorPanelContainer />;
  }
}

function CreatorPanelContainer() {
  const { currentFormState, dispatch } = useSettingsTreeReducerContext();
  const form = useDynamicCreatorForm(currentFormState, dispatch);

  if (!currentFormState || !form) {
    return null;
  }

  return <SettingsEditorPanel dynamicForm={form} currentFormState={currentFormState} />;
}

function EditorPanelContainer() {
  const { state, dispatch, currentFormState } = useSettingsTreeReducerContext();
  const selectedNode = state.selectedNode;
  const parentNode = useMemo(() => {
    if (!selectedNode?.parentId) return undefined;
    const allNodes = [...state.projectTree.nodes, ...state.projectChildrenTree.nodes, ...state.placeholderNodes];
    return allNodes.find((n) => n.id === selectedNode.parentId);
  }, [selectedNode?.parentId, state.projectTree.nodes, state.projectChildrenTree.nodes, state.placeholderNodes]);
  const form = useDynamicEditorForm(selectedNode, currentFormState, dispatch, parentNode);

  if (!currentFormState || !selectedNode || !form) {
    return null;
  }

  return <SettingsEditorPanel dynamicForm={form} currentFormState={currentFormState} />;
}
